import React from 'react';
import { Flex, FlexProps, Text } from '@indeed/ifl-components';

export interface CardHeaderProps extends FlexProps {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    supertitle?: React.ReactNode;
    iconBefore?: React.ReactNode;
    iconAfter?: React.ReactNode;
    'data-testid'?: string;
}

export const CardHeader: React.FunctionComponent<CardHeaderProps> = ({
    iconBefore,
    iconAfter,
    title,
    supertitle,
    subtitle,
    sx,
    'data-testid': dataTestId = 'CardHeader',
    ...props
}) => (
    <Flex sx={{ gap: 2, alignItems: 'center', ...sx }} {...props} as="span">
        {!!iconBefore && (
            <Flex
                as="span"
                sx={{ flexShrink: 0, justifyContent: 'center', alignItems: 'center' }}
                data-testid={`${dataTestId}-icon-before`}
            >
                {iconBefore}
            </Flex>
        )}
        <Flex as="span" sx={{ flexDirection: 'column', gap: 1, flexGrow: 1 }}>
            {!!supertitle && (
                <Text
                    data-testid={`${dataTestId}-supertitle`}
                    sx={{ fontWeight: 'normal' }}
                    variant="secondary"
                    level={1}
                >
                    {supertitle}
                </Text>
            )}
            <Text
                data-testid={`${dataTestId}-title`}
                sx={{ color: 'comp.cardHeader.foreground', fontSize: 3, fontWeight: 'bold' }}
            >
                {title}
            </Text>
            {!!subtitle && (
                <Text
                    data-testid={`${dataTestId}-subtitle`}
                    sx={{ fontWeight: 'normal' }}
                    variant="secondary"
                    level={1}
                >
                    {subtitle}
                </Text>
            )}
        </Flex>
        {!!iconAfter && (
            <Flex as="span" sx={{ flexShrink: 0, justifyContent: 'center', alignItems: 'center' }}>
                {iconAfter}
            </Flex>
        )}
    </Flex>
);
